function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { jsx as _jsx } from "react/jsx-runtime";
import Error from "next/error";
import { PureComponent } from "react";
import BbVisitorSyncComponent from "/components/pages/external/bb-visitor-sync/bb-visitor-sync-component";
const getHostName = (url)=>{
    try {
        const parsedUrl = new URL(url);
        const hostname = parsedUrl.hostname;
        const simplifiedHostname = hostname.replace(/^www\./, "");
        return simplifiedHostname;
    } catch (error) {
        return null;
    }
};
class BbVisitorSync extends PureComponent {
    static getInitialProps({ req, res }) {
        return _async_to_generator(function*() {
            var _req_query;
            const WHITE_LIST = new Set([
                "workforms.com",
                "mondayspaces.webflow.io",
                "mondayspaces.com"
            ]);
            const source = decodeURIComponent((req === null || req === void 0 ? void 0 : (_req_query = req.query) === null || _req_query === void 0 ? void 0 : _req_query.tsrc) || "");
            const host = getHostName(source);
            if (!WHITE_LIST.has(host)) {
                res.statusCode = 404;
            }
            const statusCode = res.statusCode;
            return {
                statusCode,
                source
            };
        })();
    }
    render() {
        const { source, statusCode } = this.props;
        if (statusCode !== 200) return /*#__PURE__*/ _jsx(Error, {
            statusCode: statusCode
        });
        return /*#__PURE__*/ _jsx(BbVisitorSyncComponent, {
            source: source
        });
    }
}
export { BbVisitorSync as default };
BbVisitorSync.defaultProps = {};
